import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AauthService } from 'src/app/services/aauth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Utilities } from 'src/app/services/utilities';
import { AlertService, DialogType, MessageSeverity } from 'src/app/services/alert.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { DBkeys } from 'src/app/services/db-keys';
import { LocalStoreManager } from 'src/app/services/local-store-manager.service';
import { RegisterService } from '../register.service';
import { FormGroup, FormControl, Validators, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { RespCheckEmailModel } from 'src/app/models/register.model';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

declare function InitMyJs(): void;                                                                                      // fake to skip ide error.

@Component({
	selector: 'app-register1',
	templateUrl: './register1.component.html',
	styleUrls: ['./register1.component.scss']
})

export class Register1Component implements OnInit, AfterViewInit {
	isClaim = false;
	isLoading = true;
	submitted = false;
	canContinue = false;
	public frmReg: FormGroup;
	respModel: RespCheckEmailModel;
	@ViewChild('registerConsumer', { static: true }) radioRegisterConsumer: ElementRef;
	@ViewChild('registerProfessional', { static: true }) radioRegisterProfessional: ElementRef;
	@ViewChild('registerExpert', { static: true }) radioRegisterExpert: ElementRef;

	constructor(
		private alertService: AlertService,
		private router: Router,
		public authService: AauthService,
		private configurations: ConfigurationService,
		private localStorage: LocalStoreManager,
		public registerService: RegisterService,
		private route: ActivatedRoute
	) {

		this.route.queryParams.subscribe(async params => {
			const claimParm = params['isClaim'];
			if (claimParm !== undefined) {
				if (claimParm === 'true') {
					this.isClaim = true;
				}
			}

			const flyout = params['fly'];
			if (flyout === '1') {
				this.registerService._isFlyout = true;
			}

			if (this.isClaim) {
				let corp = params['corp'];
				const pId = params['pId'];

				try {
					corp = parseInt(corp);
				} catch { }

				this.localStorage.savePermanentData(this.isClaim, DBkeys.LOCAL_KEY_ISCLAIM);
				this.localStorage.savePermanentData(pId, DBkeys.LOCAL_KEY_PID);
				this.localStorage.savePermanentData(corp, DBkeys.LOCAL_KEY_CORP);

				if (this.isClaim) {
					this.authService.regModel2.memberType = 5;
					this.router.navigate(['/register/step2']);
				} else {
					this.processClaim(corp, pId);
				}
			}
		});
	}

	ngOnInit(): void {
		this.registerService.regStep = 1;
		try {
			InitMyJs();                                                                                                       // Init function.jss
		} catch (error) {
			console.error(error);
		}
		this.respModel = new RespCheckEmailModel();
		this.frmReg = new FormGroup({
			email: new FormControl('', [Validators.required, Validators.email], this.isEmailExists()),
		});
		this.isLoading = false;
		if (this.isClaim) {
			this.registerService.regStep = 2;
		} else {
			this.authService.regModel2.memberType = 5;
		}
	}

	ngAfterViewInit(): void {
		const email = this.checkLocalStorageForEmail();
		if (email != null && email !== undefined) {
			this.Email.setValue(email);
		}
	}

	checkLocalStorageForEmail() {
		// 	let email = this.localStorage.getData(DBkeys.LOCAL_KEY_EMAIL);
		return this.localStorage.getData(DBkeys.LOCAL_KEY_EMAIL);
	}

	isEmailExists(): AsyncValidatorFn {
		return (control: FormControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
			if (control.hasError('email')) { return null; }
			this.isLoading = true;
			return this.authService.getEmailInformation(control.value).pipe(
				map(res => {
					let retFalse = true;
					this.respModel = res;
					retFalse = res.emailError;
					this.isLoading = false;
					if (!retFalse) {
						if (!this.respModel.emailAlreadyInUse) {
							this.canContinue = true;
							if (this.respModel.hasProfessionalRec) {
								this.authService.regModel2.memberType = 5;
								this.triggerRegisterOptionClick(5);
								this.respModel.hasProfileToClaim = true;
							} else {
								// this.authService.regModel2.MemberType = 1;
								// this.triggerRegisterOptionClick(1);
								this.respModel.hasProfileToClaim = false;
							}
						} else {
							this.canContinue = false;
						}
					} else {
						this.canContinue = true;
					}
					return (retFalse) ? { emailExists: true } : null;
				}),
				catchError(err => {
					console.log(err);
					this.respModel = new RespCheckEmailModel();
					this.isLoading = false;
					return of([]);
				})
			);
		};
	}

	public hasError = (controlName: string, errorName: string) => {
		return this.frmReg.controls[controlName].hasError(errorName);
	}

	async processClaim(corp, pId) {
		this.startProcess();
		try {
			const response = await this.authService.signupWithEmail(pId, corp, true);
			this.onSuccessProcess(response, true, pId);
		} catch (error) {
			this.onFailProcess(error);
		}
	}

	startProcess() {
		this.isLoading = true;
		this.alertService.startLoadingMessage();
	}

	offerAlternateHost() {
		if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
			this.alertService.showDialog('Dear Developer!\nIt appears your backend Web API service is not running...\n' +
				'Would you want to temporarily switch to the online Demo API below?(Or specify another)',
				DialogType.prompt,
				(value: string) => {
					this.configurations.baseUrl = value;
					this.configurations.apiUrl = value;
					this.alertService.showStickyMessage('API Changed!', 'The target Web API has been changed to: ' + value, MessageSeverity.warn);
				},
				null,
				null,
				null,
				this.configurations.apiUrl);
		}
	}

	onFailProcess(error: any) {
		this.isLoading = false;
		this.alertService.stopLoadingMessage();
		this.alertService.showError(error);
	}

	onSuccessProcess(response: any, isClaim: boolean, pId: number) {
		this.isLoading = false;
		this.alertService.stopLoadingMessage();
		if (response.emailError) {
			this.alertService.showError(response.emailErrorMessage);
			return;
		}
		if (response.emailAlreadyInUse && (response.memberStatus > 1)) {
			this.alertService.showError(response.emailErrorMessage);
			return;
		}

		if (this.Email !== undefined) {
			this.localStorage.savePermanentData(this.Email.value, DBkeys.LOCAL_KEY_EMAIL);
		}
		this.localStorage.savePermanentData(response, DBkeys.LOCAL_KEY_REG);
		this.localStorage.savePermanentData(isClaim, DBkeys.LOCAL_KEY_ISCLAIM);
		this.localStorage.savePermanentData(pId, DBkeys.LOCAL_KEY_PID);

		const resp = JSON.parse(response);
		if (resp.emailAlreadyInUse && resp.memberStatus === -1) {
			this.registerService.regStep = 3;
			this.router.navigate(['/register/step3']);
			this.alertService.showInfo(resp.resultMessage + ' Check your email and confirm your account.');
			return;
		}

		this.registerService.regStep = 2;
		this.router.navigate(['/register/step2']);
	}

	async signInWithGoogle() {
		if (this.isLoading) {
			return;
		}

		this.startProcess();
		try {
			const response = await this.authService.signupWithGoogle(this.authService.regModel2.corpType);
			this.onSuccessProcess(response, false, 0);
		} catch (error) {
			console.log(error);
			this.onFailProcess(error);
		}
	}

	async signInWithFB() {
		if (this.isLoading) { return; }

		this.startProcess();
		try {
			const response = await this.authService.signupWithFacebook(this.authService.regModel2.corpType);
			this.onSuccessProcess(response, false, 0);
		} catch (error) {
			this.onFailProcess(error);
		}
	}

	async onSubmit() {
		if (this.isLoading) { return; }

		this.submitted = true;

		if (this.Email.value == null || this.Email.value === '') {
			this.alertService.showWarning('input email');
		}

		if (!this.frmReg.valid) { return; }

		this.startProcess();
		try {
			const response = await this.authService.signupWithEmail(0, this.authService.regModel2.corpType, false, this.Email.value);
			this.onSuccessProcess(response, false, 0);
		} catch (error) {
			this.onFailProcess(error);
		}
	}

	get isValidEmail(): boolean {
		let ret = false;
		ret = this.frmReg.get('email').valid;
		return ret && this.canContinue;
	}

	get Email() {
		return this.frmReg.get('email');
	}

	radioChangeHandler(type: number) {
		this.authService.regModel2.memberType = type;
		this.setSelectedRegisterOption(this.authService.regModel2.memberType);
	}

	setSelectedRegisterOption(type: number) {
		switch (type) {
			case 1:
				this.radioRegisterConsumer.nativeElement.setAttribute('checked', 'checked');
				break;
			case 5:
				this.radioRegisterProfessional.nativeElement.setAttribute('checked', 'checked');
				break;
			case 9:
				this.radioRegisterExpert.nativeElement.setAttribute('checked', 'checked');
				break;
		}
	}

	triggerRegisterOptionClick(type: number) {
		switch (type) {
			case 1:
				this.radioRegisterConsumer.nativeElement.click();
				break;
			case 5:
				this.radioRegisterProfessional.nativeElement.click();
				break;
			case 9:
				this.radioRegisterExpert.nativeElement.click();
				break;
		}
	}
}
